export const SubAbasEmpenhos = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/proaq/empenhos/ficha/${id}/dadosgerais`,
  },
  {
    label: 'Dados Gerais',
    rota: `/daf/proaq/empenhos/ficha/${id}/dadosgerais`,
  },
];

export const SubAbasEmpenhosNovo = [
  {
    label: 'Dados Gerais',
    rota: `/daf/proaq/empenhos/ficha/dadosgerais`,
  },
];
